// import Image from "next/image";
import React from "react";

export const ImageDialog = ({ image }: { image : string }) => {
  return (
      <div className="">
        <img src={image} alt="image-dialog"  className="h100 w100 "/>
      </div>
  );
};
